import asyncComponent from 'util/asyncComponent'

/* warnung: webpack does some magic with the code splitting here
do not try to factor loading of dependenciees into a generalized function */

export const customerRoutes = [
  {
    path: '/customer/dashboard',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/DashboardPage'))
  },
  {
    path: '/customer/profile',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/ProfilePage'))
  },
  {
    path: '/customer/project/create',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/Projects/CreateProjectPage'))
  },
  {
    path: '/customer/project/order/:projectId',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/Projects/OrderProjectPage'))
  },
  {
    path: '/customer/project/show/:projectId',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/Projects/ShowProjectPage'))
  },
  {
    path: '/customer/projects',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/Projects/ListProjectsPage'))
  },
  {
    path: '/customer/task/show/:taskId',
    component: asyncComponent(() => import('../Linkgua/Pages/Customers/Tasks/ShowTaskPage'))
  },
  {
    component: asyncComponent(() => import('components/Error404'))
  }
]




// WEBPACK FOOTER //
// ./app/customerRoutes.js